import _ from 'lodash';
export const joinLocation = (locations) => {
    return _.filter(locations, (location) => location === 0 || !!location).join('.');
};
